/**
 * Centralized feature flags read from VITE_FEATURE_* env vars.
 * All flags default to false (disabled) unless explicitly set to "true".
 */

export const featureFlags = {
  /** Standalone payment links (debt collection, manual links). Disabled by default; use invoice-attached payment links instead. */
  standalonePaymentLinks: import.meta.env.VITE_FEATURE_STANDALONE_PAYMENT_LINKS === 'true',
} as const;
